<template>
  <div>
    <input
      type="number"
      pattern="\d*"
      class="micr-entry__input"
      @keyup="handleBlur"
      :id="name"
      :name="name"
      v-model="routingNumber" />
    <span v-show="bankName" class="micr-entry__note">
      <i class="fas fa-university"></i>{{bankName}}
    </span>
    <span v-show="routingNumber && !bankName" class="micr-entry__note">
      <i class="fas fa-university"></i>Bank not recognised
    </span>
    <span v-show="checksumFailed" class="micr-entry__note micr-entry__note--alert">
      <i class="fas fa-exclamation-circle"></i>Check digit does not add up — re-check the digits
    </span>
  </div>
</template>
<script>
  // Same ABA check digit the server enforces (Utils::AbaRouting), echoed here
  // so a transposed digit shows up before the form is submitted.
  const ABA_WEIGHTS = [3, 7, 1, 3, 7, 1, 3, 7, 1]

  function abaChecksumValid(routing) {
    if(!/^\d{9}$/.test(routing)) { return false }

    const sum = routing.split("").reduce((acc, digit, index) => acc + (parseInt(digit, 10) * ABA_WEIGHTS[index]), 0)
    return sum % 10 === 0
  }

  export default {
    created() {
      this.handleBlur()
    },
    props: ["name", "routing"],
    data() {
      return {
        routingNumber: this.routing,
        bankName: null
      }
    },
    computed: {
      checksumFailed() {
        return this.routingNumber && this.routingNumber.length === 9 && !abaChecksumValid(this.routingNumber)
      }
    },
    methods: {
      handleBlur() {
        if(this.routingNumber.length > 5) {
          this.$http.get("/api/v1/app/admin/routings/" + this.routingNumber).then(response =>{
            this.bankName = response.body.bank_name
          })
        }
      }
    }
  }
</script>
